import { render, staticRenderFns } from "./ZYDetail.vue?vue&type=template&id=932da1e4&scoped=true&"
import script from "./ZYDetail.vue?vue&type=script&lang=js&"
export * from "./ZYDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZYDetail.vue?vue&type=style&index=0&id=932da1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932da1e4",
  null
  
)

export default component.exports